<template>
  <div>
    <v-simple-table fixed-header fixed-footer height="350px" class="elevation-0">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Job Order ID</th>
            <th class="text-left">Quantity/Weight</th>
            <th class="text-left">Unit Type</th>
            <th class="text-left">Date Added</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in job_order_materials" :key="item.pivot.id" style="cursor: pointer">
            <td class="text-left">{{ item.pivot.job_order_id }}</td>
            <td class="text-left">{{ parseFloat(item.pivot.quantity).toLocaleString() }}</td>
            <td class="text-left">{{ item.unit_type }}</td>
            <td class="text-left">{{ item.created_at }}</td>
          </tr>
          <tr v-if="job_order_materials.length == 0">
            <td colspan="5" style="height:300px;text-align: center">
              No records found
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: ['job_order_materials', 'checkbox'],
  data: function() {
    return {};
  },
  methods: {
    ...mapActions([])
  }
};
</script>
